import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllCurrencies } from "app/main/flights/store/currencies-list.slice";
import { AppState } from "app/store";

export type Currency = { id: string; isoCode: string; name?: string };

export const useCurrencies = () => {
  const dispatch = useDispatch();
  const { currencies, loading } = useSelector(
    (s: AppState) => s.flights.currenciesList
  ) as { currencies?: Currency[]; loading?: boolean };

  useEffect(() => {
    if (!currencies || currencies.length === 0) dispatch(fetchAllCurrencies());
  }, [dispatch]); // eslint-disable-line

  const getDefaultId = (iso = "EUR") =>
    currencies?.find((c) => c.isoCode === iso)?.id ?? "";

  return { currencies, loading: !!loading, getDefaultId };
};
